import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/WizardSpearPhishingCampaign/GenerateEmailsStep'

export const GET_EMAILS = createAsyncTypes('GET_EMAILS', typeKey)
export const UPDATE_PARTICIPANTS = createAsyncTypes('UPDATE_PARTICIPANTS', typeKey)
export const UPDATE_EMAIL = createAsyncTypes('UPDATE_EMAIL', typeKey)
export const RETRIEVE_EMAIL = createAsyncTypes('RETRIEVE_EMAIL', typeKey)
export const GET_LANDING_DOMAIN_LIST = createAsyncTypes('GET_LANDING_DOMAIN_LIST', typeKey)
export const SPEAR_PHISHING_CAMPAIGN_DATA_POLLING = createAsyncTypes(
  'SPEAR_PHISHING_CAMPAIGN_DATA_POLLING',
  typeKey
)

export const FEEDBACK = {
  UP: 1,
  DOWN: 2,
}
